export enum SelectType {
  Text = 'text',
  Combo = 'combo',
  InlineH3 = 'inline-h3',
  InlineH4 = 'inline-h4',
  InlineP2 = 'inline-p2',
}
